<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-dialog v-model="isOpen" max-width="1000px">
		<v-card>
			<v-card-title>
				<span class="headline"> Zatwierdzenie sprawozdania </span>
			</v-card-title>
			<v-card-text>
				<v-container grid-list-md>
					<v-layout row align-center>
						<v-flex xs1/>
						<v-flex xs4>
							<v-subheader><strong>Zatwierdzony wkład własny</strong></v-subheader>
						</v-flex>
						<v-flex xs5>
							<egranty-number-input-field
								label="Zatwierdzony wkład własny"
								type="number"
								:suffix="' PLN'"
								v-model="data.ownContribution"
								aria-label="label for text"
								for="project-report-approval-dialog-own-contribution"
								id="project-report-approval-dialog-own-contribution"
							/>
						</v-flex>
					</v-layout>
					<v-layout row align-center>
						<v-flex xs1/>
						<v-flex xs4>
							<v-subheader><strong>Zatwierdzona kwota dotacji</strong></v-subheader>
						</v-flex>
						<v-flex xs5>
							<egranty-number-input-field
								label="Zatwierdzona kwota dotacji"
								type="number"
								:suffix="' PLN'"
								v-model="data.approvedDonation"
								aria-label="label for text"
								for="project-report-approval-dialog-approved-donation"
								id="project-report-approval-dialog-approved-donation"
							/>
						</v-flex>
					</v-layout>
					<v-layout row align-center>
						<v-flex xs1/>
						<v-flex xs4>
							<v-subheader><strong>Data zatwierdzenia sprawozdania</strong></v-subheader>
						</v-flex>
						<v-flex xs5>
							<v-menu
								:close-on-content-click="false"
								:nudge-right="40"
								:return-value.sync="data.approvalDate"
								full-width
								lazy
								min-width="290px"
								offset-y
								ref="approvalDateMenu"
								transition="scale-transition"
								v-model="approvalDateMenu"
							>
								<template v-slot:activator="{ on }">
									<v-text-field
										browser-autocomplete="off"
										aria-label="report approval date"
										label="Data zatwierdzenia sprawozdania"
										for="project-report-approval-dialog-approval-date"
										id="project-report-approval-dialog-approval-date"
										readonly
										v-model="data.approvalDate"
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker no-title scrollable
									:first-day-of-week="1"
									v-model="data.approvalDate" locale="pl-PL">
									<v-spacer></v-spacer>
									<v-btn @click="approvalDateMenu = false" color="primary" flat>Powrót</v-btn>
									<v-btn @click="$refs.approvalDateMenu.save(data.approvalDate)"
										color="primary"
										flat>OK
									</v-btn>
								</v-date-picker>
							</v-menu>
						</v-flex>
					</v-layout>
					<v-layout row align-center>
						<v-flex xs1/>
						<v-flex xs9>
							<v-alert
								:value="true"
								type="info"
								color="info"
							>
								<div>Po zatwierdzeniu sprawozdania należy wypełnić ocenę współpracy!</div>
								<div>Informacja o zatwierdzeniu sprawozdania zostanie przekazana do oferenta!</div>
							</v-alert>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" @click="approve"
					:disabled="!data.ownContribution || !data.approvedDonation || !data.approvalDate">Zatwierdź
				</v-btn>
				<v-btn color="blue" @click="close">Anuluj</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import EgrantyNumberInputField from "../../../../genericComponents/EgrantyNumberInputField";

	export default {
		name: "ProjectReportApprovalDialog",
		components: {EgrantyNumberInputField},
		watch: {
			dialog (val) {
				this.isOpen = val;
			},

			isOpen (val) {
				if (!val) {
					this.data = {
						ownContribution: '',
						approvedDonation: '',
						approvalDate: ''
					};
					this.$emit("update:dialog", false);
				}
			}
		},

		data () {
			return {
				isOpen: false,
				approvalDateMenu: false,
				data: {
					ownContribution: '',
					approvedDonation: '',
					approvalDate: ''
				}
			};
		},

		methods: {
			approve () {
				this.$emit("approve-report", this.data);
				this.close();
			},

			close () {
				this.isOpen = false;
			}
		},

		props: {
			dialog: {type: Boolean, default: false}
		}
	};
</script>

<style scoped>

</style>
